import type { SetPromotedTpye } from 'actions/promoted/types';

export const SET_PROMOTED: SetPromotedTpye = '@@sidebar/promoted/SET_PROMOTED';
